// store frequently used values resolved from states,
// for easy access from child components & modals
export const resolve = {
    companyId: null,
    credentials$: null,
    currentCompany: null,
};



// WEBPACK FOOTER //
// ./src/portal/init/store.js